const SelectOneList=[
    "downstream",
    "intronic",
    "exonic",
    "UTR3",
    "upstream;downstream",
    "UTR5",
    "UTR5;UTR3",
    "intergenic",
    "exonic;splicing",
    "upstream",
    "splicing"
    ]
    let selectoneOptions=[]
    SelectOneList.map(v=>{
        selectoneOptions.push({label:v,value:v})
    })
    export default selectoneOptions